import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface Props { children: React.ReactNode; }

/**
 * Redirects authenticated users with `mustChangePassword === true` to
 * `/change-password`. Pass-through otherwise. Wraps everything that lives
 * inside `<AppShell>` so the user cannot reach any module until they change.
 */
const MustChangePasswordGate: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user?.mustChangePassword && pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
};

export default MustChangePasswordGate;
